import { Tag } from 'antd';
import type { ColumnType } from 'antd/es/table/interface';

import type { IParticipant } from '@/api/endpoints/schools/schoolParticipants';
import { PARTICIPANT_STATUS_TO_TAG_SETTINGS } from '@/shared/consts';

import styles from './UsersPage.module.scss';

export const getColumnsData = () =>
  [
    {
      title: 'ФИО',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      render: (_, { status }) => (
        <Tag
          className={styles.tag}
          color={PARTICIPANT_STATUS_TO_TAG_SETTINGS[status].color}
        >
          {PARTICIPANT_STATUS_TO_TAG_SETTINGS[status].text}
        </Tag>
      ),
    },
  ] as ColumnType<IParticipant>[];
